<div class="relative block" [class.animate-pulse]="loading()">
    <sh-dropdown
        #dropdown
        [label]="label()"
        [disabled]="loading() || disabled() || isDisabled()"
        [hint]="hint()"
        [attr.multi-select]="multiSelect() ? true : null"
        [attr.mandatory]="mandatory() ? true : null"
        [attr.condensed]="condensed() ? true : null"
        [attr.error]="error() ? true : null"
        [attr.error-message]="errorMessage()"
        [attr.editable]="searchable() ? true : null"
        display="label"
        [class]="class()"
    >
        @for (option of options(); track option.value) {
            <sh-menu-item
                [label]="option.label | translate"
                [value]="option.value"
                [disabled]="option.disabled || false"
                [active]="isOptionActive(option.value)"
                (click)="handleMenuItemClick(option.value)"
            ></sh-menu-item>
        }
    </sh-dropdown>
</div>
